export const toggleSidebar = (value = undefined) => {
  return async (dispatch) => {
    await dispatch({
      type: "TOGGLE_SIDEBAR",
      payload: value
    });
  };
};
